import { Routes as Rotas, Route } from 'react-router-dom';
import Layout from '../layout/layout';
import Home from '../pages/Home';
import Login from '../pages/Login/Login';
import Logout from '../pages/Logout/Logout';
import ProtectedRoute from './protectedRoute';
import { manutencao } from '../environment/environment';
import Manutencao from '../pages/Manutencao/Manutencao';
import Resolucoes from '../pages/Resolucoes/Resolucoes';
import Eventos from '../pages/Eventos/Eventos';
import DiefInfo from '../pages/DiefInfo/DiefInfo';
import ArrecadacaoInfo from '../pages/ArrecadacaoInfo/ArrecadacaoInfo';

const Routes = () => {
  const isAmbienteManutencao = manutencao.isAmbienteManutencao === 'true';
  return (
    <Rotas>
      <Route element={<Layout />}>
        <Route
          path='/'
          element={isAmbienteManutencao ? <Manutencao /> : <Home />}
        />
        <Route
          path='login'
          element={
            <ProtectedRoute
              checkAccess={() => !isAmbienteManutencao}
              fallbackPath='/'
            >
              <Login />
            </ProtectedRoute>
          }
        />
        <Route
          path='logout'
          element={
            <ProtectedRoute
              checkAccess={() => !isAmbienteManutencao}
              fallbackPath='/'
            >
              <Logout />
            </ProtectedRoute>
          }
        />
        <Route path='resolucoes' element={<Resolucoes />} />
        <Route path='eventos' element={<Eventos />} />
        <Route path='info-dief' element={<DiefInfo />} />
        <Route path='info-arrecadacao' element={<ArrecadacaoInfo />} />
      </Route>
    </Rotas>
  );
};

export default Routes;
